<template>
  <div id="app" class="ly-data-center">
    <router-view />
    <div id="tools-affix">
      <PdfToImage />
    </div>
  </div>
</template>

<script>
import PdfToImage from '@/views/data-center/components/PdfToImage/index.vue'
import util from '@/libs/util'
export default {
  name: 'App',
  components: {
    PdfToImage
  },
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  created() {
    this.i18nHandle(this.$i18n.locale)
  },
  methods: {
    i18nHandle(val, oldVal) {
      util.cookies.set('lang', val)
      document.querySelector('html').setAttribute('lang', val)
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/style/public-class.scss';
#tools-affix {
  position: fixed;
  right: 0;
  bottom: 20%;
  z-index: 99999999;
  .pdf-to-image {
    &:hover {
      .pdf-to-image__trigger {
        transform: scale(1.2);
      }
    }
    .pdf-to-image__trigger {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background-color: #fff;
      border-radius: 6px 0 0 6px;
      transition: all 0.15s ease-in-out;
      box-shadow: 0 2px 6px 0 #456be533;
    }
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/App.vue"
}
</vue-filename-injector>
